import { AbilityBuilder, Ability } from '@casl/ability';
import { ADMIN, EMPLOYEE } from './roles';

const ability = (user) => {
  const { rules, can, cannot } = AbilityBuilder.extract();

  if (user) {
    switch (user.role) {
      case ADMIN:
        can('manage', 'all');
        can('search', 'Paycheck');
        cannot('update', 'Profile');
        break;
      case EMPLOYEE:
      default:
        can('read', 'Paycheck');
        can('update', 'Profile');
    }
  }
  return new Ability(rules);
};

export default ability;



// WEBPACK FOOTER //
// ./src/abilities/index.js